module.exports = __webpack_public_path__ + "static/bsas011-ada5e3ffc47928b6666cb1d6e57ff6bd.jpg";